export const breakpoints = {
  xs: 320,
  sm: 550,
  md: 768,
  lg: 1024,
  lgxl: 1200,
  xl: 1400,
  mega: 1920,
};

export const grid = {
  one36th: 0.0277778,
  two36th: 0.0555556,
  three36th: 0.0833333,
  four36th: 0.1111111,
  five36th: 0.1388889,
  six36th: 0.1666667,
  seven36th: 0.1944444,
  eight36th: 0.2222222,
  nine36th: 0.25,
  ten36th: 0.2777778,
  eleven36th: 0.3055556,
  twelve36th: 0.3333333,
  thirteen36th: 0.3611111,
  fourteen36th: 0.3888889,
  fifteen36th: 0.4166667,
  sixteen36th: 0.4444444,
  seventeen36th: 0.4722222,
  eighteen36th: 0.50,
  nineteen36th: 0.5277778,
  twenty36th: 0.5555556,
  twentyOne36th: 0.5833333,
  twentyTwo36th: 0.6111111,
  twentyThree36th: 0.6388889,
  twentyFour36th: 0.6666667,
  twentyFive36th: 0.6944444,
  twentySix36th: 0.7222222,
  twentySeven36th: 0.75,
  twentyEight36th: 0.7777778,
  twentyNine36th: 0.8055556,
  thirty36th: 0.8333333,
  thirtyOne36th: 0.8611111,
  thirtyTwo36th: 0.8888889,
  thirtyThree36th: 0.9166667,
  thirtyFour36th: 0.9444444,
  thirtyFive36th: 0.9722222,
  thirtySix36th: 0.100,
};

